import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row } from "reactstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Fn_AddEditData, Fn_DisplayData } from "../../store/Functions";
import { API_WEB_URLS } from "../../constants/constAPI";
import ReactToggle from "react-toggle";

function AddEdit_ItemTypeMaster() {
  const API_URL_SAVE = `${API_WEB_URLS.ItemTypeMaster}/0/token`;
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/ItemTypeEdit/Id`;

  const [state, setState] = useState({
    id: 0,
    formData: {
      Name: "",
      fileUpload: null,
      IsActive: false,
    },
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
    const navigate = useNavigate()

  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;

    if (Id > 0) {
      setState((prevState) => ({
        ...prevState,
        id: Id,
      }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
    }
  }, [location.state, dispatch]);

  const validationSchema = Yup.object({
    Name: Yup.string().required("Name is required"),
    IsActive: Yup.boolean().required("Active status is required"),
  });

 

  const handleSubmit = (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const formData = new FormData();
    formData.append("Name", values.Name);
    formData.append("IsActive", values.IsActive);
    formData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      '/ItemTypeMaster'
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={state.formData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values }) => (
          <Form className="form-horizontal">
            <Row>
              <Col lg="6" className="mb-3">
                <label htmlFor="Name" className="form-label">
                  Name
                </label>
                <Field className="form-control" type="text" name="Name" />
                <ErrorMessage name="Name" component="div" className="text-danger" />
              </Col>
            </Row>

           

            <Row>
              <Col lg="2">
                <label htmlFor="IsActive" className="form-label">Active</label>
              </Col>
              <Col lg="2">
                <ReactToggle
                  checked={values.IsActive}
                  onChange={() => setFieldValue("IsActive", !values.IsActive)}
                />
                <ErrorMessage name="IsActive" component="div" className="text-danger" />
              </Col>
            </Row>

            <Row>
              <Col lg="6" className="mt-3">
                <button type="submit" className="btn btn-primary btn-block">
                  Submit
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddEdit_ItemTypeMaster;
